/**
 * Se estiver utilizando esta extensão com quasar v2:
 * https://github.com/gtm-support/vue-gtm/tree/main
 *
 * Caso esteja utilizando esta extensão com quasar v1:
 * https://github.com/gtm-support/vue-gtm/tree/vue2-gtm
 *
 * OBS: A configuração do "vueRouter: router" já é feita automaticamente pela extensão.
 */
module.exports = {
  id: process.env.ANALYTICS_KEY
}
